import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=b56dbe94&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=b56dbe94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56dbe94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b56dbe94')) {
      api.createRecord('b56dbe94', component.options)
    } else {
      api.reload('b56dbe94', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=b56dbe94&scoped=true&", function () {
      api.rerender('b56dbe94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Mo2X9fRQS6NY/JS/teamMember.vue"
export default component.exports